export enum ObjectTypeEnum {
  SCENARIO,
  PROJECT,
}
